<script lang="ts">
import { defineComponent, ref } from 'vue'
import { useGtm } from '@/hooks/useGtm'
export default defineComponent({
  name: 'LogoChildRender',
  props: {
    item: {
      type: Object,
      default: () => ({} as AnyObject),
    },
    index: {
      type: Number,
      default: () => 1,
    },
    currentBridge: {
      type: String,
      default: '',
    },
  },
  emits: ['toggleLogo', 'handleChange'],
  setup(_, { emit }) {
    const { pushGtm } = useGtm()
    const refSwitcherAction = ref()
    const refColorAction = ref()

    const toggleLogo = (key, value) => {
      emit('toggleLogo', { key, value })
      pushGtm(refSwitcherAction.value?.$el)
    }

    const handleChange = (key, value) => {
      emit('handleChange', { key, value })
      pushGtm(refColorAction.value?.$el)
    }

    return {
      refSwitcherAction,
      refColorAction,
      toggleLogo,
      handleChange,
    }
  },
})
</script>

<template>
  <div class="col-6">
    <q-card class="q-mr-md bg-transparent" flat>
      <q-item class="q-pa-none">
        <q-item-section>
          <div class="row items-center q-mb-sm">
            <span class="text-caption">
              {{ item.label }} / {{ item.disabled ? 'なし' : 'あり' }}
            </span>
            <!-- <q-toggle
              color="primary"
              size="lg"
              ref="refSwitcherAction"
              :disable="item.disabled"
              :model-value="item.isShow"
              :glasson-click="item.switcherActionKey"
              @update:model-value="(value) => toggleLogo(item.key, value)"
            /> -->
          </div>
          <q-separator />
          <div v-if="!item.disabled" class="q-py-xs">
            <p class="text-caption text-black q-mb-xs">
              カラー
            </p>
            <q-btn-toggle
              ref="refColorAction"
              :model-value="item.value"
              spread
              rounded
              :disable="item.disabled"
              :glasson-click="item.colorActionKey"
              no-caps
              glossy
              toggle-color="primary"
              color="white"
              text-color="primary"
              size="sm"
              :options="[
                { label: 'Black', value: 'black' },
                { label: 'White', value: 'white' },
                { label: 'Clear', value: 'clear' },
              ]"
              @update:model-value="(value) => handleChange(item.key, value)"
            />
          </div>
          <div v-else style="height: 58px" />
        </q-item-section>
      </q-item>
    </q-card>
  </div>
</template>
